import { Box, Button, Divider, FormControlLabel, Radio, RadioGroup, Typography, useTheme } from "@material-ui/core";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { firstLetterUppercase } from "../../utils/first-letter-uppercase";
import CheckedRadio from "../icons/Controls/CheckedRadio";
import UncheckedRadio from "../icons/Controls/UncheckedRadio";
import DayRangeFilter from "./DayRangeFilter";
import { DateFilterState, defaultDateRanges, isFilterEmpty, TableFilterAction } from "./models";
import MonthRangeFilter from "./MonthRangeFilter";

function DateRangeFilter(props: { filter: DateFilterState; usePopover?: boolean; dispatcher: (action: TableFilterAction) => void }) {
	const { t } = useTranslation();
	const { spacing } = useTheme();
	function dispatchChangeRangeType(rangeType: DateFilterState["rangeType"]) {
		props.dispatcher({ type: "set-range-type", path: props.filter.field as string, rangeType });
	}
	const dateRanges = props.filter.customRanges || defaultDateRanges;

	return (
		<Box>
			<Box display="flex" pb={1}>
				{!props.filter.isOnlyCustomAvailable && (
					<Box pl={3} py={1}>
						<RadioGroup
							value={props.filter.rangeType}
							onChange={(_, value) => dispatchChangeRangeType(value as DateFilterState["rangeType"])}
						>
							{dateRanges.map((rangeType, index) => (
								<FormControlLabel
									key={index}
									value={rangeType}
									control={<Radio icon={<UncheckedRadio />} checkedIcon={<CheckedRadio />} />}
									label={firstLetterUppercase(t(rangeType))}
								/>
							))}
						</RadioGroup>
					</Box>
				)}
				{!!props.filter.monthFormat ? <MonthRangeFilter {...props} /> : <DayRangeFilter {...props} />}
			</Box>
			{props.usePopover && (
				<Box pb={1}>
					<Divider />
					<Button
						variant="text"
						color="primary"
						style={{ textTransform: "none" }}
						disabled={isFilterEmpty(props.filter)}
						onClick={() => props.dispatcher({ type: "clear-selection", path: props.filter.field as string })}
					>
						<Box mt={1}>
							<Typography variant="caption" color="primary">
								{t("clear-filter")}
							</Typography>
						</Box>
					</Button>
				</Box>
			)}
			{props.filter.description && (
				<Box pb={1}>
					<Divider />
					<Typography variant="body2" color="textSecondary" style={{ padding: spacing(3) }}>
						{t(props.filter.description)}
					</Typography>
				</Box>
			)}
		</Box>
	);
}

export default memo(DateRangeFilter);
